export const MAX_CHAT_PROMPT_LENGTH = 1200;
